import { Page } from '@/core/architecture'

import { MailAuthArtistTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MailAuthArtist Page
 * Implemented as a practical sample.
 */
export const MailAuthArtist: Page = () => {
  const { state, actions } = useViewModel()

  return <MailAuthArtistTemplate state={state} {...actions} />
}
